var map = {
	"./en-AU.json5": [
		1161,
		5
	],
	"./en-CA.json5": [
		1162,
		6
	],
	"./en-US.json5": [
		1163,
		7
	],
	"./en.json5": [
		1164,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1156;
module.exports = webpackAsyncContext;